import React from 'react';
import { InboxIcon, FileCheck2, ClipboardEdit, CheckCircle2, Archive, ArchiveIcon, CheckCircle2Icon } from 'lucide-react';

const styles = {
    primaryColor: '#F76707',
    secondaryColor: '#0A6EBD'
};

const TrackingTimeline = ({ etapes }) => {
    const getStepIcon = (stepName) => {
        const icons = {
            'Réception': InboxIcon,
            'Qualification': FileCheck2,
            'Traitement': ClipboardEdit,
            'Validation': CheckCircle2Icon,
            'Clôture': ArchiveIcon
        };
        return icons[stepName] || FileCheck2;
    };

    const getStatusStyle = (status) => ({
        completed: { color: '#198754', background: '#e8f5e9' },
        in_progress: { color: '#0d6efd', background: '#e3f2fd' },
        default: { color: '#6c757d', background: '#f8f9fa' }
    }[status] || { color: '#6c757d', background: '#f8f9fa' });

    return (
        <div className="card mb-3">
            <div className="card-body p-3">
                <h3 style={{ color: styles.secondaryColor }} className="h5 mb-3">
                    Suivi de votre réclamation
                </h3>
                <div className="timeline-container">
                    {etapes.map((etape, index) => {
                        const IconComponent = getStepIcon(etape.nom);
                        const statusStyle = getStatusStyle(etape.status);

                        return (
                            <div key={index} className="timeline-item">
                                <div className="timeline-icon" style={statusStyle}>
                                    <IconComponent size={18} />
                                </div>
                                <div className="timeline-content">
                                    <div className="content-header">
                                        <span className="step-name">{etape.nom}</span>
                                        <span className="step-date">{etape.date}</span>
                                    </div>
                                    <p className="step-desc">{etape.description}</p>
                                    <div className="step-assignee">
                                        <span>{etape.assigneA.service}</span>
                                        {etape.assigneA.nom && <span> - {etape.assigneA.nom}</span>}
                                    </div>
                                    {etape.assigneA.commentaire && (
                                        <div className="step-comment">
                                            {etape.assigneA.commentaire}
                                        </div>
                                    )}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
            <style>
                {`
                    .timeline-container {
                        position: relative;
                        padding-left: 32px;
                    }

                    .timeline-container::before {
                        content: '';
                        position: absolute;
                        left: 15px;
                        top: 0;
                        bottom: 0;
                        width: 1px;
                        background: #dee2e6;
                    }

                    .timeline-item {
                        position: relative;
                        padding-bottom: 1rem;
                    }

                    .timeline-item:last-child {
                        padding-bottom: 0;
                    }

                    .timeline-icon {
                        position: absolute;
                        left: -32px;
                        width: 32px;
                        height: 32px;
                        border-radius: 50%;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        border: 2px solid #fff;
                        box-shadow: 0 0 0 2px #e9ecef;
                    }

                    .timeline-content {
                        background: #fff;
                        padding: 0.5rem 0.75rem;
                        border-radius: 4px;
                        margin-bottom: 0.5rem;
                    }

                    .content-header {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        margin-bottom: 0.25rem;
                    }

                    .step-name {
                        font-weight: 600;
                        font-size: 0.9rem;
                    }

                    .step-date {
                        font-size: 0.8rem;
                        color: #6c757d;
                    }

                    .step-desc {
                        margin: 0.25rem 0;
                        font-size: 0.9rem;
                        color: #495057;
                    }

                    .step-assignee {
                        font-size: 0.8rem;
                        color: #0d6efd;
                        margin-top: 0.25rem;
                    }

                    .step-comment {
                        margin-top: 0.25rem;
                        padding: 0.5rem;
                        background: #f8f9fa;
                        border-radius: 4px;
                        font-size: 0.8rem;
                        color: #6c757d;
                        font-style: italic;
                    }
                `}
            </style>
        </div>
    );
};

export default TrackingTimeline;